import React, { Component } from "react";
import videoCancel from "images/video-model-cancel.png";
import "./index.less";

function App(props){
    if(props.visible){
        return (
            <div className="video-model-wrap" >
                <div className={props.size === "small" ? "video-model-small" : "video-model"}>
                    <div className="video-model-header">
                        <span>{props.title}</span>
                        {/*<img src={videoCancel} onClick={props.closeModel}/>*/}
                    </div>
                    {props.children}
                </div>
            </div>
        )
    }else{
        return null;
    }
}

export default App;